<script setup lang="ts">
    import { useToastStore } from '@/stores/toast.store';
    import { useConfirmationStore } from '@/stores/confirmation.store';
    import { ref, inject, Ref, onMounted, reactive } from 'vue';
    import { useRoute } from 'vue-router';
    import { AMOUNT_FORMAT_CONFIG } from '@/utils';
    import axios from 'axios';

    const route = useRoute();
    const toastStore = useToastStore();
    const loading = ref(false);
    const collectivite = inject<Ref<any>>('collectivite');
    const profil = reactive({
        taux_interet: 0,
        indexes: Array.from({ length: 12 }, (_, index) => 0)
    });

    onMounted(() => {
        const dbProfil: any = (route.meta.item as any).profil;
        if (dbProfil) {
            Object.assign(profil, {
                taux_interet: dbProfil.taux_interet,
                indexes: dbProfil.index ?? profil.indexes
            });
        }
    })

    async function onSubmit() {
        try {
            loading.value = true;
            await axios.post(`/backoffice/collectivites/${collectivite?.value.id}/save_profilfinancier`, profil);
            toastStore.success("Profil enregistré");
        } catch(error: any) {
            toastStore.error(error.message || 'Une erreur est survenue lors de la requête au serveur.');
        } finally {
            loading.value = false;
        }
    }
</script>
<template>
    <section class="s20_mobile px-4">
        <div class="widget px-7 py-7">
            
            <div class="s10_mobile container-full-2"> 
                <h2 class="flex align-items-center gap-4 font-medium text-primary-color my-5">
                    <img src="/public/icons/icon-info-perso.svg" class="size-l" alt="" />
                    Profil Financier
                </h2>
            </div> 

            <div class="s10 mt--5-5 flex-right gap-3">
                <!-- <button class="btn lg py-3 white2 active">
                    <img src="public/icons/coop-finance/icon-consulter.svg" class="btn-icon" alt="" />
                    <span>Carte</span>
                </button> -->
                <!-- <button class="btn-ultra lg shadow-200 color2">
                    <div class="btn-show">
                        <img src="public/icons/coop-finance/icon-consulter.svg" class="btn-icon" alt="" />
                        <span>Bloquer</span>
                    </div>
                    <div class="btn-loading">
                        <div class="loader-dots"></div>
                    </div>
                </button> -->
            </div>
            <div class="clear-both h-5"></div>

            <div class="s20 items-center gap-6 px-5 pb-6 collapse-content active">
                <!-- <h3 class="mb-2 px-5">Retrait de carte</h3> -->
                <div class="s20 px-4">
                    <div class="form-field-floating lg reactive my-4">
                        <money3 class="form-input" v-model="profil.taux_interet" name="profil.taux_interet" id="profil.taux_interet" placeholder="" v-bind="AMOUNT_FORMAT_CONFIG" :readonly="collectivite?.verrouille"></money3>
                        <label for="taux_interet">Taux Interets Microfinance <b class="color-danger">*</b></label>
                    </div>
                </div>
                <div class="grid6 grid-row-gap-0 px-4 my-1">
                    <div class="form-field-floating lg reactive my-4" v-for="(indexEl, i) of profil.indexes" :key="'index_' + (i + 1)">
                        <input type="number" class="form-input" name="index[]" :id="'index_' + (i + 1)" placeholder="" v-model="profil.indexes[i]" :readonly="collectivite?.verrouille">
                        <label :for="'index_' + (i + 1)">Index {{ i + 1 }} <b class="color-danger">*</b></label>
                    </div>
                </div>

                <div class="s14_mobile px-4 flex">
                    &nbsp;
                </div>
                <div class="s6_mobile px-4 mt-4 flex">
                    <custom-button :classesList="'btn-ultra lg w-100 shadow-0'" @click="onSubmit" v-if="!collectivite?.verrouille">
                        <img src="/icons/icon-valider.svg" class="btn-icon" alt="" />
                        <span>Valider</span>
                    </custom-button>
                </div>
            </div>

            <div class="clear-both"></div>
        </div>
    </section>
</template>